<template>
    <div>
        <sui-button :content="currentValue.content" v-on:click="onClick($event)" />
    </div>
</template>

<script>

export default {
    name: 'ModuleButton',
    data () {
        return {
            currentValue: {}
        }
    },
    props: {
        parameters: {
            type: Object,
        },
    },
    watch: {
        currentValue: {
            handler(val) {
                this.$emit('parameters-update', val);
            },
            deep: true
        }
    },
    methods: {
        onClick(e) {
            e.preventDefault();
            
            let eventName = this.currentValue.event;
            
            if (eventName=='postDeviceData')
                this.$emit('postDeviceData', this.currentValue);
            
            
            
        }
    },
    mounted() {
        this.currentValue = JSON.parse(JSON.stringify(this.parameters));
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
